// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 0.5C13.1905 0.5 14.2406 1.09427 14.8724 2H21.5V22H2.5V2H9.12759C9.75936 1.09427 10.8095 0.5 12 0.5ZM9.50015 8.08569L5.58594 11.9999L9.50015 15.9141L10.9144 14.4999L8.41436 11.9999L10.9144 9.49991L9.50015 8.08569ZM18.4144 11.9999L14.5001 8.08569L13.0859 9.49991L15.5859 11.9999L13.0859 14.4999L14.5001 15.9141L18.4144 11.9999Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-assignment-code-filled')
export default class AssignmentCodeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'assignment-code-filled',
    }
  }
}
